<script>
import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Module9Item',
  props: {
    headline: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor }
}
</script>

<template>
  <div
    class="item"
    :style="{boxShadow: size === 'large' ? 'rgba(0, 0, 0, 0.35) 0px 5px 15px' : `0 3px 10px 0 ${getShadowColor(path)}`}"
    :class="{'item-large': size === 'large'}"
  >
    <div class="item-box">
      <p class="item-title">{{ headline || '' }}</p>
      <p class="item-name">——— {{ name || '' }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item {
  width: 450px;
  height: 150px;
  border-radius: 5px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .item-box {
    background-color: #C32425;
    width: 440px;
    height: 136px;
    border-radius: 3px;
    margin-top: 3px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    color: #FCC50D;
    font-size: 18px;
    font-weight: 400;
    font-family: xinwei;
    padding: 20px;
  }
  .item-title {
    width: 400px;
    height: 100px;
    line-height: 26px;
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
  .item-name {
    width: 400px;
    text-align: end;
  }
}
.item-large {
  width: 510px;
  height: 170px;
  .item-box {
    width: 500px;
    height: 156px;
  }
  .item-title {
    width: 460px;
    height: 90px;
  }
  .item-name {
    width: 460px;
    text-align: end;
  }
}
</style>
